import type { TableProps } from 'antd';
 export interface DataType {
  id: number,
  productId: string,
  productName: string,
  riskAmount: string|number,
  productPrice: string|number,
  parvalue: string|number,
  status: number,
  productType: string,
  supplyChannelId: number,
  innerProductId: string
}

export const column: TableProps<DataType>['columns'] = [
  {
    title: '权益活动编号',
    dataIndex: 'productId',
    key: 'productId',
    width: 100,
  },
  {
    title: '权益活动名称',
    dataIndex: 'productName',
    key: 'productName',
  },
  {
    title: '权益活动渠道',
    dataIndex: 'supplyChannelName',
    key: 'supplyChannelName',
  },
  // {
  //   title: '权益活动风控金额',
  //   dataIndex: 'riskAmount',
  //   key: 'riskAmount',
  //   width: 100,
  // },
  // {
  //   title: '权益活动售价',
  //   dataIndex: 'productPrice',
  //   key: 'productPrice', 
  //   width: 100,
  // },
  {
    title: '权益包',
    dataIndex: 'innerProductName',
    key: 'innerProductName', 
    width: 200,
  },
  // {
  //   title: '权益活动面值',
  //   dataIndex: 'parvalue',
  //   key: 'parvalue',
  //   width: 100,
  // }

];